import { render, staticRenderFns } from "./PageNotFoundPage.vue?vue&type=template&id=155d125d&scoped=true&"
var script = {}
import style0 from "./PageNotFoundPage.vue?vue&type=style&index=0&id=155d125d&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "155d125d",
  null
  
)

export default component.exports